module.exports = __webpack_public_path__ + "static/img/Principal.06e6bd01.png";